import React, { useEffect, useState } from 'react';
import { accessService } from '../../services/central-api/access';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';


type Props = {
    actingBodyId: number | null;
    zIndex: number;
} & ({
    form?: undefined;
    fieldName?: undefined;
    customValidations?: undefined;
    pattern?: undefined;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function ActingBodiesCommandsDropdown({ value, setValue, actingBodyId, zIndex, form, fieldName }: Props) {
    const [selectableActingBodyCommands, setSelectableActingBodyCommands] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodyCommands({ actingBodyId }: { actingBodyId: number; }) {
        try {
            const actingBody = await accessService.getActingBody(actingBodyId);

            if (!actingBody.actingBodyCommands) {
                setSelectableActingBodyCommands([]);
            } else {
                setSelectableActingBodyCommands([
                    ...actingBody.actingBodyCommands.map((role) => {
                        return {
                            value: role.id || 0,
                            label: role.name
                        };
                    })
                ]);
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId) {
            getActingBodyCommands({ actingBodyId });
        }
    }, [actingBodyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('command')}
            items={selectableActingBodyCommands}
            multiple={true}
            mode='BADGE'
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={translate('command')}
                items={selectableActingBodyCommands}
                multiple={true}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                mode='BADGE'
            />
        );
    }
}

export default ActingBodiesCommandsDropdown;
